import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    header_data:{},
    footer_data:{},
    login_data:{},
    user_car_list:{},
    add_new_car:{},
    car_type_list:{},
    all_categores_list:{},
    service_by_category_list:{},
    service_by_id_list:{},
    completeAccount:{},
    check_availability_list:{},
    create_reservation_list:{},
    delete_car_res:{},
    car_info_list:{},
    days_works:{},
    spical_date:{},
    tracking_car_list:{},
    // home page 
    slider_list:{},
    about_list:{},
    category_list:{},
    service_list:{},
    counter_list:{},
    suggestion_list:{},
    contact_data:{},
    contact_form:{},
    contact_info:{},
    gallery_list:{},
    partner_list:{},
    what_we_do:{},
    before_after_list:{},
    shop_owner:{},
    our_experts:{},
    testimonial:{},
    our_story:{},
    born_to_ride:{},
    // title pages
    about_us:{},
    contact_us:{},
    works_title:{},
    project_list:{},
    // cart api
    add_main_service_res:{},
    add_sugg_servuce_res:{},
    delete_main_service_res:{},
    delete_sugg_service_res:{},
    suggestion_service_in_cart:{},
    all_cart_data:{},
    list_service_by_categ:{},
    // 
    setting:{}

  },
  getters: {
     get_header(state){
        return state.header_data;
     }, 
     get_footer(state){
      return state.footer_data;
   }, 
     get_login(state){
      return state.login_data;
   }, 
   get_user_car_list(state){
    return state.user_car_list
   },
   get_add_new_car(state){
    return state.add_new_car
   },
   get_car_type_list(state){
    return state.car_type_list
   },
   get_all_categores_list(state){
    return state.all_categores_list
   },
   get_service_by_category_list(state){
    return state.service_by_category_list
   },
   get_service_by_id_list(state){
    return state.service_by_id_list;
   },
   
   get_completeAccount(state){
    return state.completeAccount
   },
   get_check_availability(state){
    return state.check_availability_list
   },
   get_create_reservation(state){
    return state.create_reservation_list
   },
   get_delete_car_res(state){
    return state.delete_car_res
   },
   get_car_info_list(state){
    return state.car_info_list
   },
   get_days_works(state){
    return state.days_works
   },
   get_spical_date(state){
    return state.spical_date
   },
   get_tracking_car_list(state){
    return state.tracking_car_list
   },
   get_slider_list(state){
    return state.slider_list
   },
   get_about_list(state){
    return state.about_list
   },
   get_category_list(state){
    return state.category_list
   },
   get_service_list(state){
    return state.service_list
   },
   get_counter_list(state){
    return state.counter_list
   },
   get_what_we_do(state){
    return state.what_we_do
   },
   get_before_after_list(state){
    return state.before_after_list
   },
   get_our_experts(state){
    return state.our_experts;
   },
   get_shop_owner(state){
    return state.shop_owner;
   },
   get_testimonial(state){
    return state.testimonial;
   },
   get_our_story(state){
    return state.our_story;
   },
   get_born_to_ride(state){
    return state.born_to_ride;
   },
   get_suggestion_list(state){
    return state.suggestion_list;
   },
   get_contact_data(state){
    return state.contact_data;
   },
   get_contact_form(state){
    return state.contact_form;
   },
   get_contact_info(state){
    return state.contact_info;
   },
   get_gallery_list(state){
    return state.gallery_list;
   },
   get_partner_list(state){
    return state.partner_list;
   },
   get_add_main_service_res(state){
    return state.add_main_service_res;
   },
   get_add_sugg_servuce_res(state){
    return state.add_sugg_servuce_res;
   },
   get_delete_main_service_res(state){
    return state.delete_main_service_res;
   },
   get_delete_sugg_service_res(state){
    return state.delete_sugg_service_res;
   },
   
   get_suggestion_service_in_cart(state){
    return state.suggestion_service_in_cart;
   },
   get_all_cart_data(state){
    return state.all_cart_data;
   },
  //  
  get_about_us(state){
    return state.about_us;
  },
  get_works_title(state){
    return state.works_title;
  },
  get_project_list(state){
    return state.project_list;
  },
  get_list_service_by_categ(state){
    return state.list_service_by_categ;
  },
  get_setting(state){
    return state.setting;
  }
   
  
  },
  mutations: {
    set_header(state,header_data){
        state.header_data =  header_data;
    },
    set_footer(state,footer_data){
      state.footer_data =  footer_data;
  },
    set_login(state,login_data){
      state.login_data =  login_data;
  },
   set_user_car_list(state , user_car_list){
    state.user_car_list = user_car_list;
   },
   set_add_new_car(state , add_new_car){
    state.add_new_car = add_new_car
   },
   set_car_type_list(state,car_type_list){
     state.car_type_list = car_type_list;
   },
   set_all_categores_list(state , all_categores_list){
    state.all_categores_list = all_categores_list;
   },
   set_service_by_category_list(state , service_by_category_list){
    state.service_by_category_list = service_by_category_list;
   },
   set_service_by_id_list(state , service_by_id_list){
     state.service_by_id_list  = service_by_id_list;
   },
   set_completeAccount(state , completeAccount){
     state.completeAccount = completeAccount;
   },
   set_check_availability(state , check_availability_list){
     state.check_availability_list = check_availability_list;
   },
   set_create_reservation(state , create_reservation_list){
     state.create_reservation_list = create_reservation_list;
   },
   set_delete_car_res(state , delete_car_res){
     state.delete_car_res = delete_car_res;
   },
   set_car_info_list(state , car_info_list){
     state.car_info_list = car_info_list;
   },
   set_days_works(state , days_works){
     state.days_works = days_works
   },
   set_spical_date(state , spical_date){
     state.spical_date = spical_date
   },
   set_tracking_car_list(state , tracking_car_list){
     state.tracking_car_list = tracking_car_list;
   },
   set_slider_list(state , slider_list){
     state.slider_list = slider_list;
   },
   set_about_list(state , about_list){
     state.about_list = about_list
   },
   set_category_list(state , category_list){
   state.category_list = category_list;
   },
   set_service_list(state , service_list){
     state.service_list = service_list;
   },
   set_counter_list(state, counter_list){
     state.counter_list = counter_list
   },
   set_what_we_do(state, what_we_do){
    state.what_we_do = what_we_do
  },
  set_before_after_list(state,  before_after_list){
     state.before_after_list =  before_after_list;
   },
   set_our_experts(state , our_experts){
     state.our_experts =  our_experts;
   },
   set_shop_owner(state , shop_owner){
    state.shop_owner =shop_owner;
   },
   set_testimonial(state , testimonial ){
    state.testimonial = testimonial;
   },
   set_our_story(state , our_story){
     state.our_story = our_story;
   },
   set_born_to_ride(state , born_to_ride){
    state.born_to_ride = born_to_ride;
   },
   set_suggestion_list(state , suggestion_list){
     state.suggestion_list =  suggestion_list;
   },
   set_contact_data(state , contact_data){
     state.contact_data = contact_data;
   },
   set_contact_form(state , contact_form){
     state.contact_form = contact_form;
   },
   set_contact_info(state , contact_info){
     state.contact_info  = contact_info;
   },
   set_gallery_list(state , gallery_list){
     state.gallery_list = gallery_list;
   },
   set_partner_list(state , partner_list){
     state.partner_list = partner_list;
   },
  //  
  set_add_main_service_res(state, add_main_service_res){
     state.add_main_service_res = add_main_service_res;
   },
   set_add_sugg_servuce_res(state, add_sugg_servuce_res){
    state.add_sugg_servuce_res = add_sugg_servuce_res;
  },
   set_delete_main_service_res(state , delete_main_service_res){
     state.delete_main_service_res = delete_main_service_res;
   },
   set_delete_sugg_service_res(state , delete_sugg_service_res){
    state.delete_sugg_service_res = delete_sugg_service_res;
  },
   set_suggestion_service_in_cart(state , suggestion_service_in_cart){
     state.suggestion_service_in_cart = suggestion_service_in_cart;
   },
   set_all_cart_data(state , all_cart_data){
     state.all_cart_data = all_cart_data;
   },
   set_about_us(state , about_us){
     state.about_us = about_us;
  },
  set_works_title(state , works_title){
     state.works_title = works_title;
  },
  set_project_list(state , project_list){
     state.project_list = project_list; 
  },
  set_list_service_by_categ(state , list_service_by_categ){
     state.list_service_by_categ = list_service_by_categ;
  },
  set_setting(state , setting){
     state.setting = setting;
  }
  },
  actions: {
    async header_api({commit}){
        await axios({ method: 'get', url: '/front/header', validateStatus: () => true }).then(res=>{
            // console.log(res.data[0].options.pages,'res from header');
            commit('set_header',res.data[0].options);
        });
      },
      async footer_api({commit}){
        await axios({ method: 'get', url: '/front/footer', validateStatus: () => true }).then(res=>{
            // console.log(res.data[0].options.pages,'res from header');
            commit('set_footer',res.data[0].options);
        });
      },      
      async login_api({commit},phonenumber){
        await axios({ method: 'post', url: '/api/users/login_phone',data:{
          'phone':phonenumber
        }, validateStatus: () => true }).then(res=>{
          commit('set_login',res);
        });
      },
        async user_car_list_api({commit}){
        await axios({ method: 'get', url: '/front/user/car', validateStatus: () => true }).then(res=>{
          // console.log(res.data , 'user List cars');
          commit('set_user_car_list',res.data);
        });
      },
      async add_user_car_api({commit},newcar){
        await axios({ method: 'post', url: '/front/user/car/store',data:{
        'vehicle_type_id': newcar.vehicle_type_id,
        'matricule': newcar.matricule,
        'brand': newcar.brand,
        'model': newcar.model,
        'year' : newcar.year , 
        'color': newcar.color
        }, validateStatus: () => true }).then(res=>{
          commit('set_add_new_car',res.data);
          // this.dispatch('user_car_list_api');
        });
       
      },
      async get_car_type_api({commit}){
        await axios({ method: 'get', url: '/front/vehicle-types', validateStatus: () => true }).then(res=>{
          commit('set_car_type_list',res.data);
        });
      },
      async get_all_categores_api({commit}){
        await axios({ method: 'get', url: '/front/categories', validateStatus: () => true }).then(res=>{
          commit('set_all_categores_list',res.data);
        });
      },
      async get_service_by_category_api({commit},mycarinfo){
        // console.log(mycarinfo , 'storeinfo');
        await axios({ method: 'get', url: `/front/services/category/${mycarinfo.id}/${mycarinfo.matricule}`, validateStatus: () => true }).then(res=>{
           console.log(res.data, 'service by category api store');
          commit('set_service_by_category_list',res.data);
        });
      },
      async get_service_by_id_api({commit},id_service){
        // console.log(mycarinfo , 'storeinfo');
        await axios({ method: 'get', url: `/front/services/${id_service}`, validateStatus: () => true }).then(res=>{
          commit('set_service_by_id_list',res.data);
        });
      },

      async complete_Account_api({commit},userdata){
        await axios({ method: 'post', url: '/front/set_info',data:{
          'name':userdata.name,
          'email':userdata.email,
          'address':userdata.address,
          'city':userdata.city,
          'postal_code':userdata.postal_code,
        }, validateStatus: () => true }).then(res=>{
          commit('set_completeAccount',res);
          this.dispatch('auth/attempt');
        });
      },

      async check_availability_api({commit},reservation_data){
        await axios({ method: 'post', url: '/front/reservations/check-availability',data:{
          'reservation_date':reservation_data.reservation_date,
          'services':reservation_data.services,
          'matricule':reservation_data.matricule,
        }, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'avaliblity reservation');
          commit('set_check_availability',res.data);
        });
      },
      async create_reservations_api({commit},reservation_data){
        await axios({ method: 'post', url: '/front/reservations/store',data:{
          'reservation_date':reservation_data.reservation_date,
          'services':reservation_data.services,
          'matricule':reservation_data.matricule,
          'time_start':reservation_data.time_start,
          'client_note':reservation_data.client_note
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'create reservation');
          commit('set_create_reservation',res.data);
        });
      },
      async update_reservations_api({commit},reservation_data){
        await axios({ method: 'put', url: `/front/reservations/update/${reservation_data.reservation_id}`,data:{
          'reservation_date':reservation_data.reservation_date,
          'services':reservation_data.services,
          'matricule':reservation_data.matricule,
          'time_start':reservation_data.time_start,
          'client_note':reservation_data.client_note
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'create reservation');
          commit('set_create_reservation',res.data);
        });
      },
      async delete_car_api({commit},car_id){
        await axios({ method: 'get', url: `/front/user/car/delete/${car_id}`, validateStatus: () => true }).then(res=>{
          // console.log(res.data, 'service by category api store');
          commit('set_delete_car_res',res.data);
        });
      },
      async get_car_info_api({commit},car_number){
        await axios({ method: 'get', url: `/front/reservations/car-info/${car_number}`, validateStatus: () => true }).then(res=>{
           console.log(res, 'car info api');
          commit('set_car_info_list',res.data);
        });
      },
      async get_days_works_api({commit}){
        await axios({ method: 'get', url: `/front/work_days`, validateStatus: () => true }).then(res=>{
          commit('set_days_works',res.data.days);
          commit('set_spical_date',res.data.special_times);
          
        });
      },
      async tracking_car_api({commit},car_number){
        console.log(car_number , 'store');
        await axios({ method: 'post', url: `/front/reservations/tracking-car_services`,data:{
          'matricule' : car_number
        }, validateStatus: () => true }).then(res=>{
          console.log(res);
          commit('set_tracking_car_list',res); 
        });
      },
      async slider_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'slider home');
          commit('set_slider_list',res.data.home.home_slider); 
        });
      },
      async about_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'about  , home');
          commit('set_about_list',res.data.home.about_section); 
        });
      },
      async category_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'category home');
          commit('set_category_list',res.data.home.service_categories_section); 
        });
      },
      async service_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'service home');
          commit('set_service_list',res.data.home.service_category_section); 
        });
      },
      async counter_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'count home');
          commit('set_counter_list',res.data.home.count_section); 
        });
      },
      async wahat_we_do_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'what we do home');
          commit('set_what_we_do',res.data.home.what_we_do); 
        });
      },
      async before_after_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'before after home');
          commit('set_before_after_list',res.data.home.before_after); 
        });
      },
      async our_experts_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'our_experts home');
          commit('set_our_experts',res.data.home.our_experts); 
        });
      },
      async testimonial_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'testimonial home');
          commit('set_testimonial',res.data.home.testimonial); 
        });
      },
      async shop_owner_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'shop owner home');
          commit('set_shop_owner',res.data.home.shop_owner); 
        });
      },
      async our_story_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'our_story home');
          commit('set_our_story',res.data.home.our_story); 
        });
      },
      async born_to_ride_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'born_to_ride home');
          commit('set_born_to_ride',res.data.home.born_to_ride); 
        });
      },
      async suggestion_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'suggestoin home');
          commit('set_suggestion_list',res.data.home.suggestion_section); 
        });
      },
      async contact_data_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home/get`, validateStatus: () => true }).then(res=>{
          console.log(res , 'contact data');
          commit('set_contact_data',res.data.home.form_section); 
        });
      },
      async partners_api({commit}){
        await axios({ method: 'get', url: `/front/pages/home_page`, validateStatus: () => true }).then(res=>{
          console.log(res.data.partners , 'partners data');
          commit('set_partner_list',res.data.partners); 
        });
      },
      async contact_info_api({commit}){
        await axios({ method: 'get', url: `/front/pages/contact_us`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'contact info');
          commit('set_contact_info',res.data); 
        });
      },
      async gallery_api({commit}){
        await axios({ method: 'get', url: `/front/pages/gallery`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'gallery');
          commit('set_gallery_list',res.data); 
        });
      },
      async contact_form_api({commit} , form_data){
        await axios({ method: 'post', url: `/front/pages/home/form` , data:{
          'name':form_data.name,
          'email':form_data.email,
          'phone':form_data.phone,
          'content':form_data.message,
          'subject':form_data.subject

        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'contact form');
          commit('set_contact_form',res); 
        });
      },
      // cart Api 
      async add_main_service_cart_api({commit} , service_cart){
        console.log(service_cart , 'store cart add ');
        await axios({ method: 'post', url: `front/reservations/service-bags/services` , data:{
          'service_id':service_cart.service_id,
          'matricule':service_cart.matricule,
          'is_suggested':service_cart.is_suggested
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'Added cart');
          commit('set_add_main_service_res',res.data); 
          //this.dispatch("all_cart_data_api" , service_cart.matricule);
        });
      },
      async add_suggesion_service_cart_api({commit} , service_cart){
        await axios({ method: 'post', url: `front/reservations/service-bags/services` , data:{
          'service_id':service_cart.service_id,
          'matricule':service_cart.matricule,
          'is_suggested':service_cart.is_suggested,
          'service_master_id':service_cart.service_master_id
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'Added cart');
          commit('set_add_sugg_servuce_res',res.data); 
          // this.dispatch("all_cart_data_api" , service_cart.matricule);
        });
      },
      async delete_main_service_cart_api({commit} , service_cart){
        await axios({ method: 'delete', url: `/front/reservations/service-bags/service-bag-delete` , data:{
          'service_id':service_cart.service_id,
          'matricule':service_cart.matricule,
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'delete cart => main');
          commit('set_delete_main_service_res',res.data); 
          //this.dispatch("all_cart_data_api",service_cart.matricule);
        });
      },
      async delete_suggesion_service_cart_api({commit} , service_cart){
        await axios({ method: 'delete', url: `/front/reservations/service-bags/service-bag-delete` , data:{
          'service_id':service_cart.service_id,
          'matricule':service_cart.matricule,
        }, validateStatus: () => true }).then(res=>{
          console.log(res , 'delete cart => main');
          commit('set_delete_sugg_service_res',res.data); 
          // this.dispatch("all_cart_data_api",service_cart.matricule);
        });
      },
      async suggestion_cart_api({commit} , car_number){
        await axios({ method: 'get', url: `/front/services/suggestions/${car_number}`, validateStatus: () => true }).then(res=>{
          console.log(res , 'suggistion cart => sugg');
          commit('set_suggestion_service_in_cart',res.data); 
        });
      },
      async all_cart_data_api({commit} , car_number){
        await axios({ method: 'get', url: `/front/reservations/service-bags/${car_number}`, validateStatus: () => true }).then(res=>{
          console.log(res , 'All cart data');
          commit('set_all_cart_data',res.data); 
        });
      },

      // page title seo
      async about_title_api({commit}){
        await axios({ method: 'get', url: `/front/pages/about_us`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'about title');
          commit('set_about_us',res.data); 
        });
      },
      async works_title_api({commit}){
        await axios({ method: 'get', url: `/front/pages/works`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'Works title');
          commit('set_works_title',res.data); 
        });
      },
      async projects_api({commit}){
        await axios({ method: 'get', url: `/api/pages/works/our-projects-section`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'Projects List');
          commit('set_project_list',res.data); 
        });
      },
      async list_service_by_categ_api({commit},category_id){
        await axios({ method: 'get', url: `/front/categories/${category_id}`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'service List by cate id');
          commit('set_list_service_by_categ',res.data); 
        });
      },
      async setting_api({commit}){
        await axios({ method: 'get', url: `/api/about`, validateStatus: () => true }).then(res=>{
          console.log(res.data , 'setting');
          commit('set_setting',res.data); 
        });
      },
      
      
      
      

      
      
  }
  , modules: {
    // login auth
    auth
  }
})

